export const messages = {
  en: {
    title: {
      campaign: 'Campaign',
      seminar: 'Seminar',
      schedule: 'Schedule',

      membership_num: 'Number of Members',

      login_membership: 'Login Membership',
      membership_previous_period: 'Previous Period',
      membership_year_on_year: 'Year on Year',
      login_membership_number: 'Login Membership Number',
      login_membership_count: 'Login Membership Count',
      membership_legend_title: 'Members',
      watch_num: 'PV',
      watch_num_previous: 'Watch Num Previous',
      watch_num_current: 'Watch Num Current',

      live_playback: 'Live playback',
      live_total_playback: 'Live Total Playback',
      on_demand_total_playback: 'On-demand Total Playback',
      total_play_time: 'Total Play Time',
      total_play_rate: 'Total Play Rate',
      average_playback_time: 'Average Playback Time',
      total_playback_rate: 'Total Playback Percentage',

      live_playback_hover: `Total playback time of each member's live streaming/pseudo-live seminar during the applicable period.`,
      on_demand_playback_hover: 'Total playback time of on-demand seminars for each member during the applicable period.',
      last_viewed_hover: 'Display the latest seminar last viewed date and time',

      seminar_participants: 'Seminar Participants',
      library_views: 'Library Views',
      survey_responses: 'Survey Responses',
      overall_total: 'Total',
      overall_average: 'Average',

      member_name: 'Member Name',
      organization: 'Organization',
      address: 'Email address',
      on_demand_playback: 'On-demand Playback',
      last_viewed: 'Last viewed',

      member_list: 'Member List',
      activity_list: 'Activity List',
      activity_aggregation_summary: 'Activity Aggregation Summary',

      // アクティビティ一覧ヘッダー
      date: 'Date',
      classification: 'Classification',
      title: 'Title',
      name: 'Name',
      kana: 'Name（Kana）',
      affiliation: 'Affiliation',

      seminar_number: 'Number of Seminar Participants',
      login: 'Login',
      on_demand_playback_rate: 'On-demand Playback Rate',
      live_playback_rate: 'Live Playback Rate',

      narrowing_down: 'Narrowing Down',
      is_narrowing_down: 'Narrowing Down',
      narrow_down_activities: 'Narrow Down Activities',
      csv_export: 'CSV Export',
      enterprise_code: 'Enterprise Code',
      mail_address: 'Email',
      municipalities: 'Municipalities',
      address_building_name: 'Address / Building Name',
      campaign_name: 'Campaign Name',
      campaign_code: 'Campaign Code',
      library_name: 'Library Name',
      library_code: 'Library Code',
      survey_title: 'Survey Title',
      survey_name: 'Survey Name',
      survey_code: 'Survey Code',

      create: 'Create',
      save: 'Save',
      clear: 'Clear',
      close: 'Close',
      back: 'Back',
      ok: 'OK',
      cancel: 'Cancel',
      all: 'All',
      now_loading: 'Now Loading...',
      confirm: 'Confirmation',

      select_activity_modal_error_message: 'Please select one activity type',
      select_all: 'Select All',
      activity_type: 'Activity Type',
      seminar_type: 'Seminar Type',
      contents_type: 'Contents Type',
      playback_rate: 'Playback Rate',
      viewing_log_notice: 'Data prior to 09/01/2022 will not be displayed',

      member_register: 'Member Register',
      campaign_register: 'Campaign Register',
      campaign_cancel: 'Campaign Cancel',
      seminar_apply: 'seminar Reservations',
      seminar_entry: 'Seminar Entry',
      library_watch: 'Library Watch',
      enquete_response: 'Questionnaire Response',
      chat_response: 'Chat Response',
      chat_individual_response: 'Chat Individual Question Response',
      seminar_real_time: 'Seminar Real Time',
      seminar_pseudo_live: 'Seminar Pseudo Live',
      seminar_on_demand: 'Seminar on Demand',
      contents_video: 'Library Video',
      contents_document: 'Library Document',
      contents_other: 'Library Free Writing',
      contents_external_integration: 'Library External Integration',
      less_than_one_percent: 'Less Than 1%',
      error_text_failed: 'Data acquisition failed.',
      error_text_reload: 'Please try searching again after a while',

      seminar_classification: 'Seminar Classification',
      library_classification: 'Library Classification',
      seminar_play: 'Seminar Play',
      seminar_playback_time: 'Seminar Playback Time',
      seminar_play_rate: 'Seminar Play Rate',
      on_demand_play: 'On Demand Play',
      on_demand_playback_time: 'On Demand Playback Time',
      on_demand_play_rate: 'On Demand Play Rate',
      member_action_history: 'Member Action History',

      participating_seminars_detail: 'participating Seminars Detail',
      total_participating_seminars_text: 'You participated in a total of ${nu} seminars.',
      seminar_name: 'Seminar Name',
      viewed_date: 'Viewed Date',
      delivery_time: 'Delivery Time',
      playback_time: 'Playback Time',
      detail: 'Detail',

      real_time_live: 'Real Time Live',
      on_demand: 'On-demand',
      pseudo_live: 'Pseudo Live',
      system_linkage: 'System Linkage',
      interactive: 'Low Latency Live',
      live: 'Live',

      select_membership: 'Select output item of member information',
      profile: 'Profile',
      user_profile: 'User Profile',
      apply_profile: 'Apply Form Profile',

      no_table_data_text: 'No data matching your search criteria was found.',
      narrow_down_activities_if_necessary_narrowing_down: 'After searching in the "Narrow Down Activities" button, please search in the "Narrowing Down" button if necessary.',

      please_select: 'Please select',
      not_input: 'Not input',

      place: 'Place',
      people: 'People',

      empty_graph_text: 'No data available for display',
      registration_date: 'Registration date',
      last_login_date: 'Last login date',
      detailed_display: 'Detailed display',
      activity_history: 'Activity history',
      results: 'Results',

      chat: 'Chat',
      chat_individual: 'Chat individual',

      enquete_timing_apply: 'Preliminary Questionnaire',
      enquete_timing_before: 'Questionnaire before viewing',
      enquete_timing_after: 'Questionnaire after viewing',

      year: 'Year',
      month: 'Month',

      unfinished_seminar: 'This is a seminar that has not yet been finished.',

      chat_connected: 'Chat is ready.',
      chat_disconnected: 'Network connection has been disconnected.',

      // CSV
      csv_sample: 'CSV sample',
      encoding_sjis: 'SJIS',
      encoding_utf8: 'UTF-8',

      //その他のツールチップ
      seminar_csv_export_button_tooltip: 'When the chat, individual question, and live poll functions are turned on, a CSV for each function is output. Also, when on-demand seminar or pseudo live, CSV of the library detail information is also output. A maximum of 4 items will be output.',
      seminar_viewing_narrowing_button_tooltip: 'The PV count at the top, the seminar aggregate summary, the view retention rate graph, and the number of views graph (for on-demand seminars) will be narrowed down to only these members. Click again to cancel the narrowing.',

      conversion_tooltip: 'Displays the number of applicants, participants, and surveys associated with the campaign for the applicable period. The number of surveys is calculated only for post-viewing surveys.',

      //会員集計ページのツールチップ
      seminar_participants_tooltip: 'The number of seminars (live/pseudo-live/on-demand seminars) attended by each member during the period covered.',
      library_views_tooltip: 'Displays the number of times each member has viewed the library during the applicable period. When the same library is viewed multiple times, it is counted as the number of times it was viewed.',
      survey_responses_tooltip: 'Displays the number of survey responses for each member during the period covered.',

      seminar_participants_overall_total: 'The number of members who participated in the seminar during the applicable period (without duplication) is displayed.',
      seminar_participants_overall_average: 'Displays the average number of participants per seminar during the period covered. <br/>Calculation method: Overall total / Number of seminars during the period covered',

      library_views_overall_total: 'Displays the number of times the library was viewed during the period in question. The number of times the same library is viewed multiple times by the same viewer is counted.',
      library_views_overall_average: 'Displays the average number of views per library during the period in question. <br/>Calculation method: Total / Number of libraries viewed at least once during the period',

      survey_responses_overall_total: 'Displays the total number of survey responses that include a response date within the time period covered.',
      survey_responses_overall_average: 'Displays the average number of survey responses during the period covered. <br/>Calculation method: Overall total / Set number of surveys',

      membership_num_tooltip: 'Displays the number of newly registered and active (member status valid) members during the period covered. The previous period displays data for the period including the day before the start of the period covered by the calculation. <br/>Example: If the target period is "30 days" and the calculation covers the period from 5/1 to 5/30/2023, the previous period covers the period from 4/1 to 4/30.',
      watch_num_tooltip: 'Displays the number of PVs on the viewing page during the period covered. The previous period displays the data for the target period including the day before the start of the target period. <br/>Example: If the target period is "30 days" and the calculation covers the period from 5/1 to 30/5/2023, the previous period covers the period from 4/1 to 30/4.',
      login_membership_tooltip: 'Number of logged-in members: Displays the number of members who logged in during the period. <br/>Number of logins: Displays the total number of logins during the period.',


      live_total_playback_total_tooltip: 'Displays the total playback time of the participants (members only) of the live or pseudo-live streaming during the applicable period. <br/>Calculation method: Total playback (viewing) time for each participant',
      live_total_playback_average_tooltip: 'Displays the average playback time per participant (members only) of live or pseudo-live streaming during the applicable period. <br/>Calculation method: Total playback time / Number of viewing members',
      live_total_playback_total_rate_tooltip: 'The playback rate per participant (member only) for live or pseudo-live streaming during the applicable period is displayed. <br/>Calculation method: Total playback rate of each participant (members only) / Number of participants (members only) Playback rate per member: <br/>Playback time of members / Time from start to end of seminar delivery (delivery time)',

      on_demand_total_playback_total_tooltip: 'Displays the total replay time of participants (members only) for the on-demand seminar during the applicable period. <br/>Calculation method: Total replay (viewing) time for each participant',
      on_demand_total_playback_average_tooltip: 'Displays the average replay time per participant (members only) for the on-demand seminar during the applicable period. <br/>Calculation method: Total playback time / Number of members viewing',
      on_demand_total_playback_total_rate_tooltip: 'The replay rate per participant (member only) for on-demand seminars during the applicable period is displayed. <br/>Calculation method: Total replay rate of each participant (member only) / Number of participants (member only)  <br/>1 member replay rate: Member replay time / Time from start to end of seminar delivery (delivery time)',

      //会員集計ページの会員行動履歴ツールチップ
      member_action_seminar_number_tooltip: 'The number of seminars (live/pseudo-live/on-demand seminars) attended by each member during the period covered.',
      member_action_library_views_tooltip: 'Displays the number of times each member has viewed the library during the applicable period. When the same library is viewed multiple times, it is counted as the number of times it was viewed.',
      member_action_survey_responses_tooltip: 'Displays the number of survey responses for each member during the period covered.',
      member_action_login_tooltip: 'Displays the number of times each member has logged in during the applicable period.',
      member_action_live_playback_rate_tooltip: 'Displays the average of the total playback rate of each member\'s live distribution/pseudo-live. <br/>Calculation method: Total playback rate of each member\'s live (live-streaming/pseudo-live) / number of live shows',
      member_action_on_demand_play_rate_tooltip: 'Displays the average of the total replay rate of each member\'s on-demand seminars. <br/>Calculation method: Total replay rate of each member\'s on-demand seminars / number of live performances',

      move_to_member_analytics_page: 'Go to the Member Analysis page. You can view detailed information about each member.',

      //アクティビティ集計概要のツールチップ
      activity_aggregation_summary_seminar_number_tooltip: 'Number of seminar participants (unduplicated) to the member\'s live/pseudo-live.',
      activity_aggregation_summary_seminar_total_playback_time: 'Displays the total playback time of the member\'s live streaming/pseudo-live. <br/>Calculation method: Total playback time of each live (live streaming/pseudo-live) of the corresponding member',
      activity_aggregation_summary_seminar_play_rate: 'Displays the percentage of live streaming/pseudo-live views of the member. <br/>Calculation method: Sum of replay rate of each seminar (live streaming/pseudo-live) of the corresponding member / total number of live shows',
      activity_aggregation_summary_on_demand_number: 'Shows the number of members attending on-demand seminars (unduplicated).',
      activity_aggregation_summary_on_demand_total_playback_time: 'Displays the total playback time of the member\'s on-demand seminars. <br/>Calculation method: Total replay time of each on-demand seminar of the corresponding member',
      activity_aggregation_summary_on_demand_playback_rate: 'Displays the percentage of replay of each member\'s on-demand seminar. <br/>Calculation method: Sum of replay rate of each on-demand seminar of the corresponding member / Total number of live shows',
      activity_aggregation_summary_enquete_response_and_rate: 'Displays the number of member survey responses and the response rate. <br/>Calculation method: Response rate = number of surveys completed / number of surveys placed at seminars attended x 100',
      activity_aggregation_summary_number_of_chats: 'Displays the number of chat messages sent by members (including deleted messages).',
      activity_aggregation_summary_number_of_individual_questions: 'Displays the number of individual question submissions sent by members.',

    },
    text: {
      new_member_registered: 'New member registered',
      logged_in: 'Logged in',
      registered_in: 'Registered in',
      cancelled: 'Cancelled',
      reserved_to: 'Reserved to',
      participated_in: 'Participated in',
      viewed: 'Viewed',
      answered: 'Answered',
      sent: 'Sent',
      required: 'Required field.',
      complete: 'Completed.',
      error: 'The information you entered is incorrect. Please correct it.',
      edit: 'Edit',
      search_please: 'Please search.',
      total_count: 'Displaying %{first}-%{last} of %{total} in total',
      select_campaign: 'Please select a campaign.',
      select_seminar: 'Please select a seminar.',
      inflow_source_key: {
        help: 'This is a key that will be displayed in connection with the application URL. You can use single-byte alphanumeric characters, underscores (_), and hyphens (-).',
      },
      inflow_source_name: {
        help: 'The name that will appear on the application page; this value will be entered if Salesforce integration is turned on and the source of inflow has been set.',
      },
    },
    errors: {
      an_error_occurred: 'Error occurred.',
      internal_server_error: 'Unexpected error occurred.',
      blank: 'Required fields.',
      half_alphanumeric: 'Invalid input value. Please enter only single-byte alphanumeric characters, hyphens and underscores.',
      dropify: {
        // 以下、`{{ value }}` はDropifyのテンプレート変数（Vue-I18nのものではありません）
        too_big_file_size: 'The file size is too big ({{ value }} max).',
        extension_only: 'You can not upload extensions other than {{ value }}.',
      },
    },
  },
  ja: {
    title: {
      campaign: 'キャンペーン',
      seminar: 'セミナー',
      schedule: 'スケジュール',

      membership_num: '会員数',
      member_name: '会員名',
      login_membership: 'ログイン会員数/回数',
      membership_previous_period: '前の期間',
      membership_year_on_year: '前年比',
      login_membership_number: 'ログイン会員数',
      login_membership_count: 'ログイン回数',
      membership_legend_title: '会員数',
      watch_num: 'PV',
      watch_num_previous: '前期PV',
      watch_num_current: '今期PV',
      live_playback: 'ライブ再生',
      live_total_playback: 'ライブ合計再生',
      on_demand_total_playback: 'オンデマンド合計再生',
      total_play_time: '合計再生時間',
      total_play_rate: '合計再生率',
      average_playback_time: '平均再生時間',
      total_playback_rate: '合計再生率',
      viewing_log_notice: '2022/09/01以前のデータは表示されません',

      live_playback_hover: '各会員の対象期間内におけるセミナー(ライブ配信/疑似ライブ)の合計再生時間を表示します。',
      on_demand_playback_hover: '各会員の対象期間内におけるセミナー(オンデマンドセミナー)の合計再生時間を表示します。',
      last_viewed_hover: '最新のセミナー最終閲覧日時を表示',

      seminar_participants: 'セミナー参加者数',
      seminar_total_playback_time: 'セミナー合計再生時間',
      seminar_playback_rate: 'セミナー合計再生率',
      on_demand_total_playback_time: 'オンデマンド合計再生時間',
      enquete_response_and_rate: 'アンケート回答数（率）',
      number_of_chats: 'チャット数',
      number_of_individual_questions: '個別質問数',
      library_views: 'ライブラリ閲覧数',
      survey_responses: 'アンケート回答数',
      overall_total: '全体合計',
      overall_average: '全体平均',

      organization: '所属組織',
      address: 'アドレス',
      on_demand_playback: 'オンデマンド再生',
      last_viewed: '最終閲覧日時',

      member_list: '会員一覧',
      activity_list: 'アクティビティ一覧',
      activity_aggregation_summary: 'アクティビティ集計概要',

      // アクティビティ一覧ヘッダー
      date: '日時',
      classification: '種別',
      title: 'タイトル',
      name: '氏名',
      kana: '氏名（カナ）',
      affiliation: '所属',

      seminar_number: 'セミナー参加数',
      on_demand_number: 'オンデマンド参加数',
      login: 'ログイン',
      on_demand_playback_rate: 'オンデマンド再生率',
      live_playback_rate: 'ライブ再生率',

      narrowing_down: '絞り込み',
      is_narrowing_down: '絞り込む',
      narrow_down_activities: 'アクティビティを絞り込み',
      csv_export: 'CSV出力',
      enterprise_code: '法人コード',
      profile_item_key: 'プロフィールアイテムキー',
      profile_linkage: 'プロフィール連携',
      default_conversion: 'デフォルト変換',
      mail_address: 'メールアドレス',
      municipalities: '市区町村',
      address_building_name: '番地・建物名',
      campaign_name: 'キャンペーン名',
      campaign_code: 'キャンペーンコード',
      library_name: 'ライブラリ名',
      library_code: 'ライブラリコード',
      survey_title: 'アンケートタイトル',
      survey_name: 'アンケート名',
      survey_code: 'アンケートコード',

      create: '新規作成',
      save: '保存',
      clear: 'クリア',
      close: '閉じる',
      back: '戻る',
      ok: 'OK',
      cancel: 'キャンセル',
      all: '全て',
      now_loading: 'ロード中...',
      confirm: '確認',

      select_activity_modal_error_message: 'アクティビティの種別を1つ選択してください',
      select_all: '全てを選択',
      activity_type: 'アクティビティの種別',
      seminar_type: 'セミナー種別',
      contents_type: 'コンテンツタイプ',
      playback_rate: '再生率',

      member_register: '会員登録',
      campaign_register: 'キャンペーン登録',
      campaign_cancel: 'キャンペーンキャンセル',
      seminar_apply: 'セミナー予約',
      seminar_entry: 'セミナー参加',
      library_watch: 'ライブラリ閲覧',
      enquete_response: 'アンケート回答',
      chat_response: 'チャット回答',
      chat_individual_response: '個別質問回答',
      seminar_real_time: 'セミナー：ライブ',
      seminar_pseudo_live: 'セミナー：疑似ライブ',
      seminar_on_demand: 'セミナー：オンデマンド',
      contents_video: 'ライブラリ：動画',
      contents_document: 'ライブラリ：ドキュメント',
      contents_other: 'ライブラリ：自由記載',
      contents_external_integration: 'ライブラリ：外部連携',
      less_than_one_percent: '1%以下',
      error_text_failed: 'データ取得に失敗しました',
      error_text_reload: 'しばらくした後に再検索をお試しください',

      seminar_classification: 'セミナー種類',
      library_classification: 'ライブラリ種類',
      seminar_play: 'セミナー再生',
      seminar_playback_time: 'セミナー再生時間',
      seminar_play_rate: 'セミナー再生率',
      on_demand_play: 'オンデマンド再生',
      on_demand_playback_time: 'オンデマンド再生時間',
      on_demand_play_rate: 'オンデマンド再生率',
      member_action_history: '会員行動履歴',

      participating_seminars_detail: '参加セミナー詳細',
      total_participating_seminars_text: '合計%{param1}セミナーに参加しました',
      seminar_name: 'セミナー名',
      viewed_date: '閲覧日',
      delivery_time: '配信時間',
      playback_time: '再生時間',
      detail: '詳細',

      real_time_live: 'リアルタイムライブ',
      on_demand: 'オンデマンド',
      pseudo_live: '疑似ライブ',
      system_linkage: '他社サービス連携',
      interactive: '低遅延配信',
      live: 'ライブ',

      select_membership: '会員情報出力項目選択',
      profile: 'プロフィール',
      user_profile: '会員基本プロフィール',
      apply_profile: 'キャンペーン申込時会員プロフィール',

      no_table_data_text: '検索条件に一致するデータが見つかりませんでした。',
      narrow_down_activities_if_necessary_narrowing_down: '「アクティビティを絞り込み」で検索後、必要に応じ「絞り込み」で検索してください。',

      please_select: '選択してください。',
      please_profile_item_select: 'プロフィールアイテムキーを選択してください。',
      not_input: '未入力',

      place: '位',
      people: '人中',

      empty_graph_text: '表示できるデータがありません。',
      registration_date: '登録日',
      last_login_date: '最終ログイン',
      detailed_display: '詳細表示',
      activity_history: 'アクティビティ履歴',
      results: '成果',

      chat: 'チャット',
      chat_individual: '個別質問',

      enquete_timing_apply: '事前アンケート',
      enquete_timing_before: '閲覧前アンケート',
      enquete_timing_after: '閲覧後アンケート',

      year: '年',
      month: '月',

      unfinished_seminar: 'まだ配信終了していないセミナーです',

      chat_connected: 'チャットの準備ができました。',
      chat_disconnected: 'ネットワークが切断されました。',

      status: 'ステータス',
      status_user_help: 'アクティベーション：「アクティベーション機能」を有効の場合に適用される会員ステータス、メールアドレス認証中の会員ステータス、ログイン不可<br/>未承認：「アカウント承認機能」を有効の場合に適用される会員ステータス、ログイン不可<br/>否認：「アカウント承認機能」を有効の場合に適用される会員ステータス、ログイン不可<br/>アカウントロック：「ログイン失敗回数」を入力した場合に適用される会員ステータス、ログイン不可<br/>無効：管理画面から特定の会員をログイン無効にする場合に適用ステータス、ログイン不可',
      authority_group_ids: '制限グループ',
      authority_group_ids_for_maintenance: '管理グループ',
      is_bounce_on: 'メールアドレスが無効な会員のみ表示する',
      only_display_locked_user: 'ロックされたアカウントのみ表示する',
      first_sources: '初回流入元',
      created_at: '作成日時',
      created_at_from: '作成日時（開始）',
      created_at_to: '作成日時（終了）',
      detailed_search: '詳細検索',

      // CSV
      csv_sample: 'CSVサンプル',
      encoding_sjis: 'SJIS',
      encoding_utf8: 'UTF-8',

      //その他のツールチップ
      seminar_csv_export_button_tooltip: 'チャット・個別質問・ライブ投票機能がONの時、各機能それぞれのCSVが出力されます。また、オンデマンドセミナーまたは疑似ライブの時はライブラリ詳細情報のCSVも出力されます。最大4件出力されます。',
      seminar_viewing_narrowing_button_tooltip: '上部のPV数、セミナー集計概要、視聴維持率グラフ、再生数推移グラフ(オンデマンドセミナーの場合)が、この会員のみで絞り込まれます。再度、押下すると絞り込みを解除できます。',

      conversion_tooltip: '対象期間のキャンペーンに紐づく申し込み者数・参加者数・アンケート数を表示します。アンケート数は、閲覧後アンケートのみ計算対象です。',

      //会員集計ページのツールチップ
      seminar_participants_tooltip: '各会員の対象期間内におけるセミナー(ライブ/疑似ライブ/オンデマンドセミナー)の参加数を表示します。',
      library_views_tooltip: '各会員の対象期間内におけるライブラリの閲覧回数を表示します。同一ライブラリを複数回見た時は、閲覧回数分カウントされます。',
      survey_responses_tooltip: '各会員の対象期間内におけるアンケート回答数を表示します。',

      seminar_participants_overall_total: '対象期間内にセミナーへ参加した会員数(重複なし)を表示します。',
      seminar_participants_overall_average: '対象期間内のセミナー1件あたりの平均参加者数を表示します。<br/>計算方法：全体合計 / 対象期間内のセミナー回数',

      library_views_overall_total: '対象期間内のライブラリ閲覧回数を表示します。同じライブラリを同じ閲覧者が複数回閲覧しても回数をカウントします。',
      library_views_overall_average: '対象期間内のライブラリ1件あたりの平均閲覧回数を表示します。<br/>計算方法：全体合計 / 対象期間内に1度でも再生されたライブラリ数',

      survey_responses_overall_total: '対象期間内に回答日を含むアンケート回答数の総数を表示します。',
      survey_responses_overall_average: '対象期間内のアンケート回答数の平均を表示します。<br/>計算方法：全体合計 / 設定されたアンケート数',

      membership_num_tooltip: '対象期間内に新規登録及びアクティブ(会員ステータスが有効)な会員数を表示します。前の期間は、計算対象期間の開始日の前日を含む対象期間分のデータを表示します。<br/>例：対象期間 「30日」で計算対象期間が2023/5/1~5/30が対象の場合、前の期間は4/1〜4/30が対象',
      watch_num_tooltip: '対象期間内における視聴ページのPV数を表示します。前の期間は、計算対象期間の開始日の前日を含む対象期間分のデータを表示します。<br/>例：対象期間 「30日」で計算対象期間が2023/5/1~5/30が対象の場合、前の期間は4/1〜4/30が対象',
      login_membership_tooltip: 'ログイン会員数：対象期間内にログインした会員数を表示します。1会員1データとなります。<br/>ログイン回数：対象期間内の総ログイン回数を表示します。',


      live_total_playback_total_tooltip: '対象期間内におけるライブまたは疑似ライブ配信の参加者(会員のみ)の合計再生時間を表示します。<br/>計算方法：各参加者の再生（視聴）時間の合計',
      live_total_playback_average_tooltip: '対象期間内におけるライブまたは疑似ライブ配信の参加者(会員のみ)1人あたりの平均再生時間を表示します。 <br/>計算方法：合計再生時間 / 視聴会員数',
      live_total_playback_total_rate_tooltip: '対象期間内におけるライブ配信または擬似ライブ配信の、参加者(会員のみ)1人あたりの再生率を表示します。 <br/>計算方法：各参加者(会員のみ)の再生率の合計 / 参加者数(会員のみ) <br/>1会員の再生率：会員の再生時間 / セミナー配信開始から終了までの時間(配信時間)',

      on_demand_total_playback_total_tooltip: '対象期間内におけるオンデマンドセミナーの参加者(会員のみ)の合計再生時間を表示します。<br/>計算方法：各参加者の再生（視聴）時間の合計',
      on_demand_total_playback_average_tooltip: '対象期間内におけるオンデマンドセミナーの参加者(会員のみ)1人あたりの平均再生時間を表示します。 <br/>計算方法：合計再生時間 / 視聴会員数',
      on_demand_total_playback_total_rate_tooltip: '対象期間内におけるオンデマンドセミナーの、参加者(会員のみ)1人あたりの再生率を表示します。 <br/>計算方法：各参加者(会員のみ)の再生率の合計 / 参加者数(会員のみ) <br/>1会員の再生率：会員の再生時間 / セミナー配信開始から終了までの時間(配信時間)',

      //会員集計ページの会員行動履歴ツールチップ
      member_action_seminar_number_tooltip: '各会員の対象期間内におけるセミナー(ライブ/疑似ライブ/オンデマンドセミナー)の参加数を表示します。',
      member_action_library_views_tooltip: '各会員の対象期間内におけるライブラリの閲覧回数を表示します。同一ライブラリを複数回見た時は、閲覧回数分カウントされます。',
      member_action_survey_responses_tooltip: '各会員の対象期間内におけるアンケート回答数を表示します。',
      member_action_login_tooltip: '各会員の対象期間内におけるログイン回数を表示します。',
      member_action_live_playback_rate_tooltip: '各会員のライブ配信/疑似ライブの合計再生率の平均値を表示します。<br/>計算方法：各会員のライブ(ライブ配信/疑似ライブ)の合計再生率 / ライブ数',
      member_action_on_demand_play_rate_tooltip: '各会員のオンデマンドセミナーの合計再生率の平均値を表示します。<br/>計算方法：各会員のオンデマンドセミナーの合計再生率 / ライブ数',

      move_to_member_analytics_page: '会員分析ページへ移動します。各会員の詳細情報が閲覧できます。',

      //アクティビティ集計概要のツールチップ
      activity_aggregation_summary_seminar_number_tooltip: '会員のライブ配信/疑似ライブへのセミナー参加数(重複なし)を表示します。',
      activity_aggregation_summary_seminar_total_playback_time: '会員のライブ配信/疑似ライブの合計再生時間を表示します。<br/>計算方法：該当会員の各ライブ(ライブ配信/疑似ライブ)の再生時間の合計',
      activity_aggregation_summary_seminar_play_rate: '会員のライブ配信/疑似ライブの再生率を表示します。<br/>計算方法：該当会員の各セミナー(ライブ配信/疑似ライブ)の再生率の合計 / ライブ合計数',
      activity_aggregation_summary_on_demand_number: '会員のオンデマンドセミナーへの参加数(重複なし)を表示します。',
      activity_aggregation_summary_on_demand_total_playback_time: '会員のオンデマンドセミナーの合計再生時間を表示します。<br/>計算方法：該当会員の各オンデマンドセミナーの再生時間の合計',
      activity_aggregation_summary_on_demand_playback_rate: '会員のオンデマンドセミナーの再生率を表示します。<br/> 計算方法：該当会員の各オンデマンドセミナーの再生率の合計 / ライブ合計数',
      activity_aggregation_summary_enquete_response_and_rate: '会員のアンケート回答数と回答率を表示します。 <br/>計算方法：回答率 = アンケート回答数 / 参加したセミナーに設置されていたアンケート数×100',
      activity_aggregation_summary_number_of_chats: '会員が送信したチャット送信件数(削除分も含む)を表示します。',
      activity_aggregation_summary_number_of_individual_questions: '会員が送信した個別質問送信件数を表示します。',
    },
    text: {
      new_member_registered: '新規会員登録しました。',
      logged_in: 'ログインしました。',
      registered_in: 'に登録しました。',
      cancelled: 'をキャンセルしました。',
      reserved_to: 'に予約しました。',
      participated_in: 'に参加しました。',
      viewed: 'を閲覧しました。',
      answered: 'に回答しました。',
      sent: 'を送信しました。',
      required: '必須項目です。',
      complete: '完了しました。',
      error: '入力内容が誤っています。修正してください。',
      edit: '編集する',
      search_please: '検索を行ってください。',
      total_count: '全%{total}件中 %{first}-%{last}件を表示しています',
      select_campaign: 'キャンペーンを選択してください。',
      select_seminar: 'セミナーを選択してください。',
      inflow_source_key: {
        help: '申し込みURLに紐づいて、表示されるキーです。半角英数字とアンダーバー(_)、ハイフン(-)が使用できます。',
      },
      inflow_source_name: {
        help: '申し込みページに表示される名前です。Salesforce連携がONで流入元を設定していれば、この値が入ります。',
      },
      item_conversion_title: {
        help: '項目変換マスタ名です。任意の文字列を設定できます。',
      },
      item_conversion_default_value: {
        help: '項目変換値を指定しない場合のデフォルト値を設定できます。',
      },
    },
    errors: {
      an_error_occurred: 'エラーが発生しました。',
      internal_server_error: '予期せぬエラーが発生しました。',
      blank: '必須項目です。',
      half_alphanumeric: '入力値が無効です。半角英数字とハイフン、アンダーバーのみを入力してください。',
      dropify: {
        // 以下、`{{ value }}` はDropifyのテンプレート変数（Vue-I18nのものではありません）
        too_big_file_size: 'ファイルサイズが大きすぎます（最大 {{ value }} まで）。',
        extension_only: '{{ value }}以外の拡張子はアップロードできません。',
      },
    },
  },
  ko: {
    title: {
      campaign: '캠페인',
      seminar: '세미나',
      schedule: '일정',

      create: '새로 만들기',
      save: '보존',
      back: '돌아가기',
      ok: 'OK',
      cancel: '취소',
      all: '모두',
      now_loading: '로드 중...',
      confirm: '확인',

      not_input: '미입력',

      chat_connected: '채팅 준비가 완료되었습니다.',
      chat_disconnected: '네트워크 연결이 끊어졌습니다.',

      // CSV
      csv_sample: 'CSV 샘플',
      encoding_sjis: 'SJIS',
      encoding_utf8: 'UTF-8',
    },
    text: {
      required: '필수 항목입니다.',
      complete: '완료되었습니다.',
      error: '입력 내용이 잘못되었습니다. 수정해 주십시오.',
      edit: '편집하기',
      search_please: '검색해 주세요.',
      total_count: '모든 %{total}건 중, %{first}-%{last} 건을 표시하고 있습니다.',
      select_campaign: '캠페인을 선택해 주세요.',
      select_seminar: '세미나를 선택해 주세요.',
      inflow_source_key: {
        help: '신청 URL에 연결하여 표시되는 키입니다. 반각 영숫자와 언더바(_), 하이픈(-)을 사용할 수 있습니다.',
      },
      inflow_source_name: {
        help: '신청 페이지에 표시되는 이름이며, Salesforce 연동이 ON으로 유입처를 설정한 경우 이 값이 들어갑니다.',
      },
    },
    errors: {
      an_error_occurred: '에러가 발생했습니다.',
      internal_server_error: '예기치 못한 에러가 발생했습니다.',
      blank: '필수 항목입니다.',
      half_alphanumeric: '입력값이 유효하지 않습니다. 반각 영숫자와 하이픈, 언더바만 입력하세요.',
      dropify: {
        // 以下、`{{ value }}` はDropifyのテンプレート変数（Vue-I18nのものではありません）
        too_big_file_size: '파일 사이즈가 큽니다(최대 {{ value }}).',
        extension_only: '{{ value }} 이외의 파일 확장자는 업로드할 수 없습니다.',
      },
    },
  },
  zh: {
    title: {
      campaign: '宣传活动',
      seminar: '讲座',
      schedule: '时间表',

      create: '制作新的',
      save: '保存',
      back: '返回',
      ok: '确认',
      cancel: '取消',
      all: '全部',
      now_loading: '载入中...',
      confirm: '确认',

      not_input: '未输入',

      chat_connected: '准备好聊天了。',
      chat_disconnected: '网络连接已断开。',

      // CSV
      csv_sample: 'CSV样版',
      encoding_sjis: 'SJIS',
      encoding_utf8: 'UTF-8',
    },
    text: {
      required: '必须项目。',
      complete: '完成。',
      error: '输入的呢绒有错误，请修改。',
      edit: '开始编辑',
      search_please: '请检索。',
      total_count: '全%{total}件中 %{first}-%{last}件显示',
      select_campaign: '请检索宣传活动。',
      select_seminar: '请检索时间表。',
      inflow_source_key: {
        help: '关联到购买链接的, 并显示的关键字。可以使用半角英数字，下划线(_)和中划线(-)。',
      },
      inflow_source_name: {
        help: '在购买页面显示的名字。Salesforce关联是ON，并设置输入地址的情况下，请输入这个值。',
      },
    },
    errors: {
      an_error_occurred: '发生错误',
      internal_server_error: '发生未知错误',
      blank: '必须项目。',
      half_alphanumeric: '输入值为无效的。请输入半角英数字，下划线(_)和中划线(-)',
      dropify: {
        // 以下、`{{ value }}` はDropifyのテンプレート変数（Vue-I18nのものではありません）
        too_big_file_size: '文件尺寸过大(最大{{ value }})。',
        extension_only: '{{ value }}以外的格式无法上传。',
      },
    },
  },
};
